import api from '@http/api';


export interface IRequestCreatePessoa {
  pessoa?: {
    nome: string;
    cpfcnpj: string;
    email: string;
    telefone: string;
    data_nascimento: any;
    indicador: string;
    leu_comunicado_privacidade: boolean;
    concede_compartilhamento_dados: boolean;
    origem_captacao: string;
  };
  doacao?: {
    valor: number;
    cartao: boolean;
    boleto: boolean;
    pix: boolean;
    recorrente: boolean;
  };
  endereco?: {
    descricao: string;
    numero: string;
    complemento: string;
    bairro: string;
    cidade: string;
    cep: string;
    uf: string;
  };
  entidade: {
    nome: string;
  };
  campanha:{
    descricao: string;
  };
}

export interface IRequestCreatePessoaCredito {
  pessoa?: {
    nome: string;
    cpfcnpj: string;
    email: string;
    telefone: string;
    data_nascimento: any;
    indicador: string;
    leu_comunicado_privacidade: boolean;
    concede_compartilhamento_dados: boolean;
    origem_captacao: string;
  };
  doacao?: {
    valor: number;
    cartao: boolean;
    boleto: boolean;
    pix: boolean;
    recorrente: boolean;
  };
  endereco?: {
    descricao: string;
    numero: string;
    complemento: string;
    bairro: string;
    cidade: string;
    cep: string;
    uf: string;
  };
  entidade: {
    nome: string;
  };
  campanha:{
    descricao: string;
  };
  cartao: {
    number: string,
    verification_value: string,
    first_name: string,
    last_name: string,
    month: string,
    year: string,
  };
}

export interface IRequestCreatePessoaDebito {
  pessoa?: {
    nome: string;
    cpfcnpj: string;
    email: string;
    telefone: string;
    data_nascimento: any;
    indicador: string;
    leu_comunicado_privacidade: boolean;
    concede_compartilhamento_dados: boolean;
    origem_captacao: string;
  };
  //doacao?: {
    //valor: number;
  //};
  endereco?: {
    descricao: string;
    numero: string;
    complemento: string;
    bairro: string;
    cidade: string;
    cep: string;
    uf: string;
  };
  entidade: {
    nome: string;
  };
  campanha:{
    descricao: string;
  };
  debito_automatico: {
    convenio: string;
    vencimento: string;
    numero_agencia: string;
    digito_agencia: string;
    numero_conta: string;
    digito_conta: string;
    operacao: string;
    valor: number;
  };
}

export interface IRequestCreatePessoaEnergia {
  pessoa?: {
    nome: string;
    cpfcnpj: string;
    email: string;
    telefone: string;
    data_nascimento: any;
    indicador: string;
    leu_comunicado_privacidade: boolean;
    concede_compartilhamento_dados: boolean;
    origem_captacao: string;
  };
  //doacao?: {
    //valor: number;
  //};
  endereco?: {
    descricao: string;
    numero: string;
    complemento: string;
    bairro: string;
    cidade: string;
    cep: string;
    uf: string;
  };
  entidade: {
    nome: string;
  };
  campanha:{
    descricao: string;
  };
  debito_coelba: {
    numero_conta_energia: string;
    recorrencia: string;
    valor: number;
  };
}

class PageCadastroPessoaServices {

  public async CreatePessoa(pessoa: IRequestCreatePessoa) {
    return await api
      .post('api/v1/billing/create-billing-bank-slip-or-pix', pessoa)
      .then(response => {

        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async CreatePessoaCredito(pessoa: IRequestCreatePessoaCredito) {
    return await api
      .post('api/v1/billing/80A360260B9DCA7419F47DF9475CC7DB', pessoa)
      .then(response => {

        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async CreatePessoaDebito(pessoa: IRequestCreatePessoaDebito) {
    return await api
      .post('api/v1/billing/create-registration-debito-automatico', pessoa)
      .then(response => {

        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async CreatePessoaEnergia(pessoa: IRequestCreatePessoaEnergia) {
    return await api
      .post('api/v1/billing/create-registration-coelba', pessoa)
      .then(response => {

        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

}


{/*  FORMULARIO */}
export interface IRequestPessoa {
  pessoa?: {
    nome: string;
    cpfcnpj: string;
    email: string;
    telefone: string;
    data_nascimento: any;
    indicador: string;
    leu_comunicado_privacidade: boolean;
    concede_compartilhamento_dados: boolean;
    origem_captacao: string;
  };
  doacao?: {
    valor: number;
    cartao: boolean;
    boleto: boolean;
    pix: boolean;
    recorrente: boolean;
  };
  endereco?: {
    descricao: string;
    numero: string;
    complemento: string;
    bairro: string;
    cidade: string;
    cep: string;
    uf: string;
  };
  entidade: {
    nome: string;
  };
  campanha:{
    descricao: string;
  };
  cartao: {
    number: string,
    verification_value: string,
    first_name: string,
    last_name: string,
    month: string,
    year: string,
  };
  debito_automatico: {
    convenio: string;
    vencimento: string;
    numero_agencia: string;
    digito_agencia: string;
    numero_conta: string;
    digito_conta: string;
    operacao: string;
    valor: number;
  };
  debito_coelba: {
    numero_conta_energia: string;
    recorrencia: string;
    valor: number;
  };
}







export default PageCadastroPessoaServices;
